import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { store } from './redux/store';
import Header from './components/Header';
import { AuthProvider } from './context/AuthContext';
import { GameProvider } from './context/GameContext';
import UnauthorizedHandler from './components/UnauthorizedHandler';
import { CurrentWeekProvider } from './context/CurrentWeekContext';
import AppRoutes from './routes';
import { initializeAuth } from './redux/authSlice';
import FeedbackCollector from './components/FeedbackCollector/FeedbackCollector';
import 'bootstrap/dist/css/bootstrap.min.css';

// Create a wrapper component to handle auth initialization
const AppContent = () => {
  const dispatch = useDispatch();
  const [isInitializing, setIsInitializing] = useState(true);
  const authStatus = useSelector(state => state.auth.status);

  useEffect(() => {
    const initialize = async () => {
      console.log('Initializing application auth state');
      dispatch(initializeAuth());
      setIsInitializing(false);
    };
    initialize();
  }, [dispatch]);

  if (isInitializing || authStatus === 'loading') {
    console.log('Auth is initializing...');
    return <div>Loading...</div>; // Or your loading component
  }

  return (
    <AuthProvider>
      <CurrentWeekProvider>
        <GameProvider>
          <UnauthorizedHandler />
          <Header />
          <AppRoutes />
          <FeedbackCollector />
        </GameProvider>
      </CurrentWeekProvider>
    </AuthProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
